import React from 'react';

const ResultMessage = ({ message }) => {
  return <p className="result-message">{message}</p>;
};

export default ResultMessage;
